// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_pdfContainer__s6EIV {
  background: #ffffff;
  border-radius: 8px;
  padding: 0.5rem;
}

.styles_pdfHeader__ijzCl {
  align-items: center;
  color: #18316e !important;
  display: flex;
  justify-content: space-between;
}

.styles_pdfLogo__SoBPe {
  width: 15rem;
}

.styles_pdfContent__Fgzav {
  margin-top: 1rem;
}

.styles_pdfTable__ZwgZj {
  margin: 10px;
  border-radius: 8px;
  box-shadow: 2px 2px 5px #c9c9c9;
  text-align: center;
  width: 100%;
}

.styles_pdfTable__ZwgZj th {
  background-color: #18316e;
  border-radius: 6px;
  box-sizing: border-box;
  font-size: 1rem;
  color: #fff;
  padding: 0.2rem 0;
}

.styles_pdfTotal__Cqm-A {
  margin-left: 0.5rem;
  padding: 0.5rem;
}

.styles_btn__dialogPreview__mPU7- {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.styles_title__header__ZKzoh {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.styles_title__header__ZKzoh h2 {
  font-size: 2rem;
  color: #18316e;
  font-family: "Abhaya Libre";
  font-weight: 600;
}

.styles_title__pdf__5gQM3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.styles_title__pdf__5gQM3 h2 {
  font-size: 2rem;
  color: #18316e;
  font-family: "Abhaya Libre";
  font-weight: 600;
}

.styles_logo__pdf__thpol {
  width: 5rem;
  height: 5rem;
}

.styles_line__td__INc9Q {
  padding: 2px;
  border-left: 1px solid #d4d4d4;
  border-collapse: collapse;
  border-spacing: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Faturamento/BtnExtratorRelatorio/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;AACnB","sourcesContent":[".pdfContainer {\n  background: #ffffff;\n  border-radius: 8px;\n  padding: 0.5rem;\n}\n\n.pdfHeader {\n  align-items: center;\n  color: #18316e !important;\n  display: flex;\n  justify-content: space-between;\n}\n\n.pdfLogo {\n  width: 15rem;\n}\n\n.pdfContent {\n  margin-top: 1rem;\n}\n\n.pdfTable {\n  margin: 10px;\n  border-radius: 8px;\n  box-shadow: 2px 2px 5px #c9c9c9;\n  text-align: center;\n  width: 100%;\n}\n\n.pdfTable th {\n  background-color: #18316e;\n  border-radius: 6px;\n  box-sizing: border-box;\n  font-size: 1rem;\n  color: #fff;\n  padding: 0.2rem 0;\n}\n\n.pdfTotal {\n  margin-left: 0.5rem;\n  padding: 0.5rem;\n}\n\n.btn__dialogPreview {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.title__header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.title__header h2 {\n  font-size: 2rem;\n  color: #18316e;\n  font-family: \"Abhaya Libre\";\n  font-weight: 600;\n}\n\n.title__pdf {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.title__pdf h2 {\n  font-size: 2rem;\n  color: #18316e;\n  font-family: \"Abhaya Libre\";\n  font-weight: 600;\n}\n\n.logo__pdf {\n  width: 5rem;\n  height: 5rem;\n}\n\n.line__td {\n  padding: 2px;\n  border-left: 1px solid #d4d4d4;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pdfContainer": `styles_pdfContainer__s6EIV`,
	"pdfHeader": `styles_pdfHeader__ijzCl`,
	"pdfLogo": `styles_pdfLogo__SoBPe`,
	"pdfContent": `styles_pdfContent__Fgzav`,
	"pdfTable": `styles_pdfTable__ZwgZj`,
	"pdfTotal": `styles_pdfTotal__Cqm-A`,
	"btn__dialogPreview": `styles_btn__dialogPreview__mPU7-`,
	"title__header": `styles_title__header__ZKzoh`,
	"title__pdf": `styles_title__pdf__5gQM3`,
	"logo__pdf": `styles_logo__pdf__thpol`,
	"line__td": `styles_line__td__INc9Q`
};
export default ___CSS_LOADER_EXPORT___;
